/**
 * Número de elementos por página
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial de una plantilla de tareas
 */
export const INITIAL_TEMPLATE_STATE = {
  uuid: null,
  name: '',
  description: '',
  template_type: 'progress',
  is_active: true,
};

/**
 * Tipos de plantillas disponibles
 */
export const TEMPLATE_TYPES = {
  PROGRESS: 'progress',
  QUALITY: 'quality',
};

/**
 * Opciones para el select de tipos de plantilla
 */
export const TEMPLATE_TYPE_OPTIONS = [
  { value: '', label: 'Todos los tipos' },
  { value: TEMPLATE_TYPES.PROGRESS, label: 'Progreso' },
  { value: TEMPLATE_TYPES.QUALITY, label: 'Calidad' },
];

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  name: { width: '25%' },
  description: { width: '35%' },
  type: { width: '15%' },
  taskCount: { width: '10%' },
  createdAt: { width: '10%' },
  actions: { width: '5%' },
};

/**
 * Configuración de validaciones
 */
export const VALIDATION_RULES = {
  NAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 255,
  },
  DESCRIPTION: {
    MAX_LENGTH: 1000,
  },
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Plantilla de tareas creada exitosamente',
    UPDATE: 'Plantilla de tareas actualizada exitosamente',
    DELETE: 'Plantilla de tareas eliminada exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear la plantilla de tareas',
    UPDATE: 'Error al actualizar la plantilla de tareas',
    DELETE: 'Error al eliminar la plantilla de tareas',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    NAME_TOO_SHORT: 'El nombre debe tener al menos 3 caracteres',
    NAME_TOO_LONG: 'El nombre no puede exceder 255 caracteres',
    DESCRIPTION_TOO_LONG: 'La descripción no puede exceder 1000 caracteres',
    INVALID_TYPE: 'Tipo de plantilla inválido',
  },
  CONFIRMATION: {
    DELETE: '¿Está seguro que desea eliminar esta plantilla de tareas?',
    DELETE_WITH_TASKS: 'Esta plantilla tiene tareas asociadas. ¿Está seguro que desea eliminarla?',
  },
};

/**
 * Etiquetas para mostrar tipos de plantilla
 */
export const TYPE_LABELS = {
  [TEMPLATE_TYPES.PROGRESS]: 'Progreso',
  [TEMPLATE_TYPES.QUALITY]: 'Calidad',
};

/**
 * Colores para los chips de tipo
 */
export const TYPE_COLORS = {
  [TEMPLATE_TYPES.PROGRESS]: 'primary',
  [TEMPLATE_TYPES.QUALITY]: 'secondary',
};
